import { isProd }  from '@/commons/utils';

const URL = 'rest/model/atg/userprofiling/ProfileActor';
const CONSENT_API_KEY = isProd ? '02d83a98-b875-4588-b694-ceff0e0dd87c' : 'b542bb45-8028-4268-b5d1-fe25ce7f9fdf';

// Update personal infos (gender, names, birthdate)
export const updatePersonalInfos = params => () => new Promise((resolve, reject) => {
  const data = {
    divId: 'profileData',
    contentCollection: '/content/Web/Account/Customer Details',
    urlActor: '/atg/userprofiling/ProfileActor/update-complete-account'
  };
  const isMobileIdentifier = document.querySelector('.account-form__section').dataset.mobileidentifier;


  if(params.birthdate)            data.date = params.birthdate;
  if(params.dateOfBirth)          data.dateOfBirth = params.dateOfBirth;
  if(params.firstName)            data.firstName = params.firstName;
  if(params.lastName)             data.lastName = params.lastName;
  if(params.middleName)           data.middleName = params.middleName;
  if(params.email)                data.email = params.email;
  if(params.gender)               data.gender = params.gender;
  if(!(isMobileIdentifier === 'true')){
    if(params.mobile)               data.mobile = params.mobile;
    if(params.verificationCode)     data.verificationCode = params.verificationCode;
    if(params.mobileCountryCode)    data.mobileCountryCode = params.mobileCountryCode;
  }
  if(params.landline)             data.landline = params.landline;
  if(params.landlineCountryCode)  data.landlineCountryCode = params.landlineCountryCode;
  if(params.nationalIdType)       data.nationalIdType = params.nationalIdType;
  if(params.nationalId)           data.nationalId = params.nationalId;

  cube.ajax.post(`${URL}/update-complete-account`, data)
    .onSuccess(resolve)
    .onError(reject)
    .call();
});



// Update contact information (mobile and/or landline)
export const updateContactInfos = params => () =>  new Promise((resolve, reject) => {
  const data = {
    divId: 'profileData',
    contentCollection: '/content/Web/Account/Customer Details',
    urlActor: '/atg/userprofiling/ProfileActor/updateLoginInformation'
  };

  if(params.email)               data.email = params.email;
  if(params.mobile)              data.mobile = params.mobile;
  if(params.mobileCountryCode)   data.mobileCountryCode = params.mobileCountryCode;
  if(params.landline)            data.landline = params.landline;
  if(params.landlineCountryCode) data.landlineCountryCode = params.landlineCountryCode;
  if(params.verificationCode)    data.verificationCode = params.verificationCode;

  cube.ajax.post(`${URL}/updateLoginInformation-mobileValidation`, data)
    .onSuccess(resolve)
    .onError(reject)
    .call();
});






// Transform account to BtoB
export const transformToCompany = params => () => new Promise((resolve, reject) => {
  const data = {
    divId: 'profileData',
    contentCollection: '/content/Web/Account/Customer Details',
    urlActor: '/atg/userprofiling/ProfileActor/transformToCompany'
  };

  if(params.companyType)    data.companyType = params.companyType;
  if(params.companyName)    data.companyName = params.companyName;
  if(params.vatNumber)      data.vatNumber = params.vatNumber;
  if(params.vatNumber)      data.taxIdentification = params.vatNumber;
  if(params.registerNumber) data.registerNumber = params.registerNumber;
  if(params.nationalIdType) data.nationalIdType = params.nationalIdType;
  if(params.nationalId)     data.nationalId = params.nationalId;
  if(params.service)        data.service = params.service;

  cube.ajax.post(`${URL}/transformToCompany`, data)
    .onSuccess(resolve)
    .onError(reject)
    .call();
});




// Update professional infos
export const updateCompany = params => () => new Promise((resolve, reject) => {
  const data = {
    divId: 'profileData',
    contentCollection: '/content/Web/Account/Customer Details',
    urlActor: '/atg/userprofiling/ProfileActor/updateCompany'
  };

  if(params.companyType)    data.companyType = params.companyType;
  if(params.companyName)    data.companyName = params.companyName;
  if(params.vatNumber)      data.vatNumber = params.vatNumber;
  if(params.vatNumber)      data.taxIdentification = params.vatNumber;
  if(params.registerNumber) data.registerNumber = params.registerNumber;
  if(params.nationalIdType) data.nationalIdType = params.nationalIdType;
  if(params.nationalId)     data.nationalId = params.nationalId;
  if(params.service)        data.service = params.service;


  cube.ajax.post(`${URL}/updateCompany`, data)
    .onSuccess(resolve)
    .onError(reject)
    .call();
});






// Set Address
export const setAddress = params => () => new Promise((resolve, reject) => {
  const data = {
    divId: 'homeAddressData',
    contentCollection: '/content/Web/Account/Customer Details',
    urlActor: '/atg/userprofiling/ProfileActor/setBillingAddress'
  };

  if(params.title)                 data.title = params.title;
  if(params.firstName)             data.surname = params.firstName;
  if(params.lastName)              data.name = params.lastName;
  if(params.middleName)            data.middleName = params.middleName;
  if(params.countryCodeGeoId)      data.countryCodeGeoId = params.countryCodeGeoId;
  if(params.provinceGeoId)         data.provinceGeoId = params.provinceGeoId;
  if(params.province)              data.province = params.province;
  if(params.cityGeoId)             data.cityGeoId = params.cityGeoId;
  if(params.districtGeoId)         data.districtGeoId = params.districtGeoId;
  if(params.postalCode)            data.postalCode = params.postalCode;
  if(params.postalCodeGeoId)       data.postalCodeGeoId = params.postalCodeGeoId;
  if(params.streetNumber)          data.streetNumber = params.streetNumber;
  if(params.additionalNumber)      data.additionalNumber = params.additionalNumber;
  if(params.streetName)            data.streetName = params.streetName;
  if(params.line1)                 data.line1 = params.line1;
  if(params.line2)                 data.line2 = params.line2;
  if(params.city)                  data.city = params.city;
  if(params.mobile)                data.mobile = params.mobile;
  if(params.mobileCountryCode)     data.mobileCountryCode = params.mobileCountryCode;
  if(params.landline)              data.landline = params.landline;
  if(params.landlineCountryCode)   data.landlineCountryCode = params.landlineCountryCode;
  if(params.house)                 data.house = params.house;
  if(params.flat)                  data.flat = params.flat;
  if(params.building)              data.building = params.building;
  if(params.additionalPostalCode)  data.additionalPostalCode = params.additionalPostalCode;
  if(params.additionnalData)       data.additionnalData = params.additionnalData;
  if(params.isPrefered)            data.isPrefered = params.isPrefered;
  if(params.addInAddressBook)      data.addInAddressBook = params.addInAddressBook;
  if(params.idAddress)             data.idAddress = params.idAddress;
  if(params.orderId)               data.orderId = params.orderId;
  if(params.addressType)           data.addressType = params.addressType;

  // In complete account form, we don't re-ask firstname and lastname like we do in /account/customer-details
  // So we send same data (name = firstname and surname = lastname)
  if(params.firstName)             data.name = params.firstName;
  if(params.lastName)              data.surname = params.lastName;


  cube.ajax.post(`${URL}/setBillingAddress`, data)
    .onSuccess(resolve)
    .onError(reject)
    .call();
});




// Update Loyalty subscription
export const updateLoyalty = params => () => new Promise((resolve, reject) => {
  const country = cube.env.country;
  cube.ajax.post('api-proxy/consent_management/external/v2/metadata/consents', {
    'httpMethod': 'GET',
    'queryParameters': {'country_code': country, 'tags': 'loyalty'},
    'httpHeaders': {'X-Api-Key': CONSENT_API_KEY}
  })
    .onSuccess((response) => {
      let newData;
      const subscriptions = response.responseTO.data.responseBody.consents.purposes;
      if(subscriptions){
        const purposesList = [];
        for(let i = 0; i < subscriptions.length; i+=1) {
          if(subscriptions[i].consent_type === 'OPTIN'){
            const consentId = subscriptions[i].id;
            purposesList.push({'id': consentId, 'enabled': params.loyaltySubscription || subscriptions[i].default_value});
          }
        }
        newData = {
          consents: {
            channels: [],
            purposes: purposesList
          }
        };
        cube.ajax.post('api-proxy/consent_management/external/v1/events', {
          'httpMethod': 'POST',
          'jsonBody': newData,
          'httpHeaders': {'X-Api-Key': CONSENT_API_KEY, 'application_country_code': country, 'user_language': country}
        })
          .onSuccess(resolve)
          .onError(reject)
          .call();
      }
    })
    .onError(reject)
    .call();
});





// Update newsletter subscription
export const updateNewsletter = params => () => new Promise((resolve, reject) => {
  const acceptOptin = params.subscribeOffers === true || params.subscribeOffers === 'true';
  const country = cube.env.country;
  if(country === 'CN'){
    const data = {
      optin: acceptOptin,
    };
    cube.ajax.post(`${URL}/setUserOptin?optin=${acceptOptin}`, data);
  }else{
    let newData;
    cube.ajax.post('api-proxy/consent_management/external/v2/metadata/consents', {
      'httpMethod': 'GET',
      'queryParameters': {'country_code': country, 'tags': 'communication'},
      'httpHeaders': {'X-Api-Key': CONSENT_API_KEY}
    })
      .onSuccess((response) => {
        const subscriptions = response.responseTO.data.responseBody.consents.purposes;
        if(subscriptions){
          const purposesList = [];
          for(let i = 0; i < subscriptions.length; i+=1) {
            const consentId = subscriptions[i].id;
            if(subscriptions[i].consent_type === 'OPTIN'){
              purposesList.push({'id': consentId, 'enabled': acceptOptin});
            }else{
              purposesList.push({'id': consentId, 'enabled': subscriptions[i].default_value});
            }
          }
          newData = {
            consents: {
              channels: [],
              purposes: purposesList
            }
          };
          cube.ajax.post('api-proxy/consent_management/external/v1/events', {
            'httpMethod': 'POST',
            'jsonBody': newData,
            'httpHeaders': {'X-Api-Key': CONSENT_API_KEY, 'application_country_code': country, 'user_language': country}
          })
            .onSuccess(resolve)
            .onError(reject)
            .call();
        }
      })
      .onError(reject)
      .call();
  }
});



// WEBPACK FOOTER //
// ./src/customer/complete-account/complete-account-apis.js